module.exports = __webpack_public_path__ + "static/media/AYS_HOME.c4e8b80e.png";